import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { FormHelperText } from '@mui/material';
import { useValidationMessage } from './hooks';
import Title from '../../Title';
import Select, { NONE } from '../../../../../forms/_common/Select';
import { StyledFormControl } from './styled';
import { useNodeDataToSave } from './hooks/useNodeDataToSave';

const EventField = () => {
  const { t } = useTranslation();
  // do not destructure nodeDataToSave
  const [nodeDataToSave, updateDataToSave] = useNodeDataToSave();

  const options = nodeDataToSave?.availableEvents?.map((e) => ({
    title: e.label,
    value: e.eventType,
  }));

  const onChange = useCallback(({ target: { value } }) => updateDataToSave({ event: value !== NONE ? value : null }), [
    updateDataToSave,
  ]);

  const validationMessage = useValidationMessage('event');

  return (
    <Box>
      <Title>{t('Event')}</Title>

      <StyledFormControl fullWidth error={!!validationMessage}>
        <Select value={nodeDataToSave?.event || NONE} options={options} onChange={onChange} />
        <FormHelperText>{validationMessage}</FormHelperText>
      </StyledFormControl>
    </Box>
  );
};

export default EventField;
